// DueSoonList.js
// "Due soon" card: tests due within the next few days. Items come from
// useStudentHomeData's deriveDueSoon (WP2), already tagged/sorted/capped.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §5 (Student > DueSoonList).
import React from "react";

import HomeCard from "../primitives/HomeCard";
import HomeRow from "../primitives/HomeRow";

const DueSoonList = ({ items = [], onTestPress, onViewAll, isDarkMode = false, t = (s) => s }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <HomeCard
      title={t("Due soon")}
      action={{ label: t("All tests"), onPress: onViewAll }}
      isDarkMode={isDarkMode}
      testID="due-soon-list"
    >
      {items.map((item, index) => (
        <HomeRow
          key={item.test?.id ?? index}
          first={index === 0}
          tag={item.tag}
          title={item.test?.title}
          subtitle={item.subtitle}
          action={{
            label: t("Start"),
            onPress: () => onTestPress?.(item.test),
            primary: item.tag?.tone === "bad",
          }}
          isDarkMode={isDarkMode}
          testID={`due-soon-row-${item.test?.id ?? index}`}
        />
      ))}
    </HomeCard>
  );
};

export default DueSoonList;
